import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const Counter = ({ value, suffix = "", decimals = 0 }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const [display, setDisplay] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const controls = animate(0, value, {
            duration: 2.2,
            ease: [0.22, 1, 0.36, 1],
            onUpdate: (v) => setDisplay(v),
        });
        return () => controls.stop();
    }, [inView, value]);

    return (
        <span ref={ref}>
            {display.toFixed(decimals)}
            {suffix}
        </span>
    );
};

const STATS = [
    { value: 847, suffix: "", decimals: 0, label: "Detection Patterns", note: "Across code, config, TLS, SSH & certificates", big: true },
    { value: 28, suffix: "", decimals: 0, label: "Programming Languages", note: "Covered by automated discovery" },
    { value: 21, suffix: "", decimals: 0, label: "Crypto Algorithm Families", note: "Mapped to NIST & CNSA 2.0 guidance" },
    { value: 68, suffix: "", decimals: 0, label: "Automated Tests Passing", note: "Shipping quality from day one, founded 2026" },
];

export const Stats = () => (
    <section id="stats" data-testid="stats-section" className="relative border-y border-white/[0.06] bg-panel/40 py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal>
                <span className="mb-3 block font-mono text-xs font-semibold uppercase tracking-[0.25em] text-volt">
                    AI-Driven. Cloud-Ready. Future-Focused.
                </span>
            </Reveal>
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {STATS.map((s, i) => (
                    <Reveal key={s.label} delay={i * 0.1} className={s.big ? "sm:col-span-2" : ""}>
                        <div
                            data-testid={`stat-card-${i}`}
                            className="card-glow-border h-full rounded-2xl border border-white/[0.08] bg-card2/60 p-7"
                        >
                            <div className="font-syne text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
                                <span className="bg-gradient-to-r from-white to-slate-400 bg-clip-text text-transparent">
                                    <Counter value={s.value} suffix={s.suffix} decimals={s.decimals} />
                                </span>
                            </div>
                            <div className="mt-3 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-volt">
                                {s.label}
                            </div>
                            <p className="mt-2 text-sm text-slate-500">{s.note}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
